import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import React, { useState, useEffect } from 'react';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenPopover from '../../../Components/KenPopOver';
import KenSelectWrap from '../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import './style.css';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import AttachmentIcon from '@material-ui/icons/Attachment';
import SendIcon from '@material-ui/icons/Send';
import moment from 'moment';
import ChatLayout from './components/ChatLayout';
import ChatInput from './components/ChatInput';
import ChatData from './data.json';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    color: theme.palette.KenColors.primary,
    padding: '0',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#F14B2D',
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  normal: {
    color: '#27AE60',
    background: 'rgba(196, 196, 196, 0.2)',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  medium: {
    color: '#F2994A',
    background: 'rgba(196, 196, 196, 0.2)',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const ChatSection = (props) => {
  console.log('props', props);
  const [propsData, setPropsData] = useState([]);
  const history = useHistory();
  const classes = useStyles();
  const [chats, setChats] = useState([]);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }
    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  React.useEffect(() => {
    const data = [];
    ChatData['Chat History'].map((item) => {
      data.push({
        sender: item.sender,
        message: item.message,
        profilePic: item.profilePic,
        time: item.time,
      });
    });
    setChats(data);
    const propsData = [];
    let newProps = props.data[0];
    propsData.push(newProps);
    setPropsData(propsData);
  }, [props]);

  return (
    <Box>
      <Toolbar className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          Contract Management
        </Typography>
      </Toolbar>
      {/* </AppBar> */}
      <div className="user-details-main">
        <div className="user-details-left">
          <h5>
            Faculty:{' '}
            <b>
              {propsData[0]?.designation} {propsData[0]?.name}
            </b>
          </h5>
          <h5>
            Batch: <b>{propsData[0]?.batch}</b>
          </h5>
        </div>
        <div className="user-details-left">
          <Button variant="contained" color="success">
            Approve
          </Button>
        </div>
      </div>

      <div className="chat-box-part">
        <ChatLayout chats={chats} />

        <ChatInput
          typedMessage={typedMessage}
          messageChangeHandler={messageChangeHandler}
          sendMessageHandler={sendMessageHandler}
        />
      </div>
    </Box>
  );
};

export default ChatSection;
